import { render, staticRenderFns } from "./ContainersInfo.vue?vue&type=template&id=943e1bde&scoped=true"
import script from "./ContainersInfo.vue?vue&type=script&lang=js"
export * from "./ContainersInfo.vue?vue&type=script&lang=js"
import style0 from "./ContainersInfo.vue?vue&type=style&index=0&id=943e1bde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "943e1bde",
  null
  
)

export default component.exports